// extracted by mini-css-extract-plugin
var _1 = "nmkbQ";
var _2 = "FT6I4";
var _3 = "SNyQR";
export { _1 as "base", _2 as "errorDetails", _3 as "header" }
